import './DeliveryTime.css';
import { useTranslation } from '../../i18n/i18n';
import { delivery, Icon, not_in_stock, delivery_orange } from '../Icon/Icon';
import { DeliveryClass } from '../../types';

type DeliveryTimeProps = {
	deliveryClass: DeliveryClass;
	deliveryNotice?: string;
	textLength: 'none' | 'long' | 'short-one-line' | 'short-two-lines';
	iconSize?: number;
};

export const DeliveryTime = ({ deliveryClass, deliveryNotice = '', textLength, iconSize }: DeliveryTimeProps) => {
	const t = useTranslation().product;

	let icon = delivery;
	let shortText = '';
	let longText = '';

	if (deliveryNotice != '') {
		icon = delivery_orange;
		shortText = deliveryNotice;
		longText = deliveryNotice;
	} else {
		switch (deliveryClass) {
			case 1:
				icon = delivery;
				shortText = t.oneToTwoDays;
				longText = t.oneToTwoDays;
				break;
			case 2:
				icon = delivery_orange;
				shortText = t.twoToThreeDays;
				longText = t.twoToThreeDaysLong;
				break;
			case 3:
				icon = not_in_stock;
				longText = t.temporarilyOutOfStock;
				shortText = t.temporarilyOutOfStock;
				break;
			case 4:
				icon = delivery_orange;
				shortText = t.orderItem;
				longText = t.orderItem;
				break;
			case 5:
				icon = delivery_orange;
				shortText = t.oneToTwoDays;
				longText = t.oneToTwoDaysExternal;
				break;
			case 6:
				icon = not_in_stock;
				shortText = t.soldOut;
				longText = t.soldOut;
				break;
		}
	}

	return (
		<>
			<div className="one-line">
				<Icon size={iconSize ?? 16} shape={icon} />
				<p className="small-text">{textLength == 'long' ? longText : shortText}</p>
			</div>
		</>
	);
};
